import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

function dm_c_20_accordion_with_image(){
  const sections = document.querySelectorAll('section.c-20-accordion-with-image');
  if (!sections.length) return;

  const DURATION = 8000; // keep in sync with --acc-duration
  const TRANSITION_GAP = 800; // gap between inactive and active slide (ms)
  const REMOVE_MINH_DELAY = 850; // allow content transition to finish before removing min-height

  sections.forEach((section) => {
    const slides = Array.from(section.querySelectorAll('.swiper .swiper-slide'));
    if (!slides.length) return;

    const wrapper = section.querySelector('.swiper .swiper-wrapper');
    const toggle = section.querySelector('.accordion-autoplay-toggle');
    let index = 0;
    let timerId = null;
    let transitionTimerId = null;
    let removeMinTimer = null;
    let initialRun = true;
    let paused = false;

    const startTimer = () => {
      clearTimeout(timerId);
      if (!paused) {
        timerId = setTimeout(next, DURATION);
      }
    };

    const activate = (i) => {
      // bounds + wrap
      const newIndex = (i + slides.length) % slides.length;

      // clear any pending timers
      clearTimeout(timerId);
      clearTimeout(transitionTimerId);
      clearTimeout(removeMinTimer);

      // Lock current wrapper height so it doesn't collapse during the gap
      if (wrapper) {
        wrapper.style.minHeight = wrapper.offsetHeight + 'px';
      }

      // remove active from all slides immediately (enter "inactive" gap)
      slides.forEach(s => s.classList.remove('active'));

      // activation work
      const doActivate = () => {
        // set index and add active
        index = newIndex;
        const el = slides[index];
        // restart progress animation by forcing reflow before re-adding class
        el.classList.remove('active');
        void el.offsetWidth; // reflow to reset ::after transition
        el.classList.add('active');
        startTimer();
        initialRun = false;

        // remove the min-height after transitions complete
        const delay = REMOVE_MINH_DELAY;
        removeMinTimer = setTimeout(() => {
          if (wrapper) wrapper.style.minHeight = '';
        }, delay);
      };

      if (initialRun) {
        doActivate();
      } else {
        transitionTimerId = setTimeout(doActivate, TRANSITION_GAP);
      }
    };

    const next = () => activate(index + 1);

    // click to jump
    section.addEventListener('click', (e) => {
      const slide = e.target.closest('.swiper .swiper-slide');
      if (!slide || !section.contains(slide)) return;
      e.preventDefault();
      activate(slides.indexOf(slide));
    });

    if (toggle) {
      toggle.addEventListener('click', () => {
        paused = !paused;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? 'Resume accordion' : 'Pause accordion';
        section.querySelector('.panel')?.classList.toggle('is-paused', paused);

        clearTimeout(timerId);
        clearTimeout(transitionTimerId);

        if (!paused) {
          const current = slides[index];
          current.classList.remove('active');
          void current.offsetWidth;
          current.classList.add('active');
          startTimer();
        }
      });
    }

    // kick off
    activate(0);
  });
}

export { dm_c_20_accordion_with_image };
